import { Checkbox } from '@profgeosoft-ui/react';

import { wrap } from 'src/packages/mobx-di/wrap';

import type { TCheckBoxView, TFieldRulesData } from 'src/services/directory-service/types';

type Props = {
  fieldView: TCheckBoxView;
  value: boolean;
  fieldRulesData?: TFieldRulesData;
  isDisabled?: boolean;
  onChange(fieldId: string, value: unknown): void;
};

export const CheckboxComponent = wrap<Props>(function CheckboxComponent({
  fieldView,
  fieldRulesData,
  isDisabled,
  value,
  onChange,
}) {
  const handleChange = (value: boolean) => {
    onChange(fieldView.fieldId, value);
  };

  return (
    <Checkbox
      checked={value}
      disabled={isDisabled || fieldRulesData?.isDisabled || fieldRulesData?.isEnteringBlocked}
      onChange={handleChange}
    />
  );
});
